import { useState, useEffect } from 'react';

const Reservation = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  const handleBookNow = () => {
    window.open("https://www.opentable.com.au/restref/client/?rid=278093", "_blank");
  };

  return (
    <div className={`${isVisible ? 'page-transition-active' : 'page-transition'}`}>
      <div className="min-h-screen bg-[#EFEAE7] flex flex-col items-center justify-start pt-12 pb-8">
        <div className="w-full max-w-3xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="mb-4">
              <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-3xl md:text-4xl font-bold">MAKE A</span>
              <span className="font-['Playfair_Display_SC'] text-black text-3xl md:text-4xl font-bold ml-2">RESERVATION</span>
            </h2>
            <p className="font-['Outfit'] text-gray-700 text-base mb-8">
              Book your table online using our reservation system. For special requests or larger groups,<br />
              please contact us directly.
            </p>
            
            {/* Book Now Button */}
            <div className="flex justify-center mb-12">
              <button 
                onClick={handleBookNow}
                className="px-10 py-4 bg-[#2E492A] text-white font-medium text-lg rounded-full hover:bg-[#2E492A]/90 transition-colors"
              >
                Book Now
              </button>
            </div>
          </div>

          {/* Additional Contact Information */}
          <div className="text-center">
            <p className="font-['Outfit'] text-gray-700 text-base">
              For groups of 21 or more, please call us directly at<br />
              0449 626 583
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reservation; 